export default "__VITE_ASSET__CYlmLWoG__"